/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/WorkspaceMindmapReport', 'model/WorkspaceMindmap', 'model/FileTransferHelperEntity'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/WorkspaceMindmapReport'), require('../model/WorkspaceMindmap'), require('../model/FileTransferHelperEntity'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.WorkspaceMindmapApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.WorkspaceMindmapReport, root.ForStractionServiceApi.WorkspaceMindmap, root.ForStractionServiceApi.FileTransferHelperEntity);
  }
}(this, function(ApiClient, WorkspaceMindmapReport, WorkspaceMindmap, FileTransferHelperEntity) {
  'use strict';

  /**
   * WorkspaceMindmap service.
   * @module api/WorkspaceMindmapApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new WorkspaceMindmapApi. 
   * @alias module:api/WorkspaceMindmapApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the workspaceMindmapAddPut operation.
     * @callback module:api/WorkspaceMindmapApi~workspaceMindmapAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/WorkspaceMindmapReport} body 
     * @param {module:api/WorkspaceMindmapApi~workspaceMindmapAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.workspaceMindmapAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workspaceMindmapAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling workspaceMindmapAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/WorkspaceMindmap/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workspaceMindmapCloneGet operation.
     * @callback module:api/WorkspaceMindmapApi~workspaceMindmapCloneGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WorkspaceMindmapReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * clone
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {String} name 
     * @param {module:api/WorkspaceMindmapApi~workspaceMindmapCloneGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WorkspaceMindmapReport}
     */
    this.workspaceMindmapCloneGet = function(_4SAPIAppID, entityID, name, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workspaceMindmapCloneGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling workspaceMindmapCloneGet";
      }

      // verify the required parameter 'name' is set
      if (name == undefined || name == null) {
        throw "Missing the required parameter 'name' when calling workspaceMindmapCloneGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID,
        'name': name
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = WorkspaceMindmapReport;

      return this.apiClient.callApi(
        '/WorkspaceMindmap/clone', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workspaceMindmapCreateOrganizationMindmapGet operation.
     * @callback module:api/WorkspaceMindmapApi~workspaceMindmapCreateOrganizationMindmapGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WorkspaceMindmapReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * createOrganizationMindmap
     * @param {String} _4SAPIAppID 
     * @param {module:api/WorkspaceMindmapApi~workspaceMindmapCreateOrganizationMindmapGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WorkspaceMindmapReport}
     */
    this.workspaceMindmapCreateOrganizationMindmapGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workspaceMindmapCreateOrganizationMindmapGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = WorkspaceMindmapReport;

      return this.apiClient.callApi(
        '/WorkspaceMindmap/createOrganizationMindmap', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workspaceMindmapCreateStrategyMindmapGet operation.
     * @callback module:api/WorkspaceMindmapApi~workspaceMindmapCreateStrategyMindmapGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WorkspaceMindmapReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * createStrategyMindmap
     * @param {String} _4SAPIAppID 
     * @param {module:api/WorkspaceMindmapApi~workspaceMindmapCreateStrategyMindmapGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WorkspaceMindmapReport}
     */
    this.workspaceMindmapCreateStrategyMindmapGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workspaceMindmapCreateStrategyMindmapGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = WorkspaceMindmapReport;

      return this.apiClient.callApi(
        '/WorkspaceMindmap/createStrategyMindmap', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workspaceMindmapDeleteGet operation.
     * @callback module:api/WorkspaceMindmapApi~workspaceMindmapDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/WorkspaceMindmapApi~workspaceMindmapDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.workspaceMindmapDeleteGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workspaceMindmapDeleteGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling workspaceMindmapDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/WorkspaceMindmap/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workspaceMindmapEditPut operation.
     * @callback module:api/WorkspaceMindmapApi~workspaceMindmapEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/WorkspaceMindmap} body 
     * @param {module:api/WorkspaceMindmapApi~workspaceMindmapEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.workspaceMindmapEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workspaceMindmapEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling workspaceMindmapEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/WorkspaceMindmap/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workspaceMindmapLoadAllGet operation.
     * @callback module:api/WorkspaceMindmapApi~workspaceMindmapLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/WorkspaceMindmapReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {module:api/WorkspaceMindmapApi~workspaceMindmapLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/WorkspaceMindmapReport>}
     */
    this.workspaceMindmapLoadAllGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workspaceMindmapLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [WorkspaceMindmapReport];

      return this.apiClient.callApi(
        '/WorkspaceMindmap/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workspaceMindmapLoadGet operation.
     * @callback module:api/WorkspaceMindmapApi~workspaceMindmapLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WorkspaceMindmapReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.maxNodesCount  (default to 0)
     * @param {Integer} opts.slicingOrder  (default to 0)
     * @param {module:api/WorkspaceMindmapApi~workspaceMindmapLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WorkspaceMindmapReport}
     */
    this.workspaceMindmapLoadGet = function(_4SAPIAppID, entityID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workspaceMindmapLoadGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling workspaceMindmapLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID,
        'maxNodesCount': opts['maxNodesCount'],
        'slicingOrder': opts['slicingOrder']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = WorkspaceMindmapReport;

      return this.apiClient.callApi(
        '/WorkspaceMindmap/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workspaceMindmapStoreMindmapScreenshotPut operation.
     * @callback module:api/WorkspaceMindmapApi~workspaceMindmapStoreMindmapScreenshotPutCallback
     * @param {String} error Error message, if any.
     * @param {'String'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * storeMindmapScreenshot
     * @param {String} _4SAPIAppID 
     * @param {module:model/FileTransferHelperEntity} body 
     * @param {Integer} entityID 
     * @param {module:api/WorkspaceMindmapApi~workspaceMindmapStoreMindmapScreenshotPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'String'}
     */
    this.workspaceMindmapStoreMindmapScreenshotPut = function(_4SAPIAppID, body, entityID, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workspaceMindmapStoreMindmapScreenshotPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling workspaceMindmapStoreMindmapScreenshotPut";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling workspaceMindmapStoreMindmapScreenshotPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'String';

      return this.apiClient.callApi(
        '/WorkspaceMindmap/storeMindmapScreenshot', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
